import calcSDF from 'bitmap-sdf';
export { calcSDF as default };